document.addEventListener("DOMContentLoaded", () => {
  const futureBalanceElement = document.getElementsByClassName("future-balance")[0];
  if (futureBalanceElement) {
    const amountInputEur = document.getElementById("account_refill_amount_eur");

    const initialBalance = parseFloat(futureBalanceElement.getAttribute("data-balance") || 0);

    const updateFutureBalance = () => {
      // "1 000 000".replace(" ", "").replace(",", ".") # => '1000 000' => (parseFloat) => 1000 # KO
      // "1 000 000".replace(/ /g, "").replace(",", ".") # => '1000000' => (parseFloat) => 1000000 # OK
      const amount = parseFloat(amountInputEur.value.replace(/ /g, "").replace(",", ".")*100);
      const futureBalance = isNaN(amount) ? initialBalance : (initialBalance + amount);
      futureBalanceElement.innerHTML = (futureBalance/100).toFixed(2);
    };
    amountInputEur.addEventListener("keyup", updateFutureBalance);
    updateFutureBalance();
  };
});
